import { Component } from '@angular/core';
import {
  EquipmentStructureImportResult,
  EquipmentStructureService,
} from '../../../services/equipment-structure.service';

@Component({
  selector: 'app-equipment-structure-import',
  templateUrl: './equipment-structure-import.component.html',
  styleUrl: './equipment-structure-import.component.scss',
  standalone: false,
})
export class EquipmentStructureImportComponent {
  importFile: File | null = null;
  isImporting = false;
  importResult: EquipmentStructureImportResult | null = null;
  importError: string | null = null;

  constructor(private equipmentStructureService: EquipmentStructureService) {}

  onFileSelected(event: any): void {
    const files: File[] = event.currentFiles ?? [];
    if (files.length > 0) {
      this.importFile = files[0];
      this.importResult = null;
      this.importError = null;
    }
  }

  onImport(): void {
    if (!this.importFile) return;

    this.isImporting = true;
    this.importResult = null;
    this.importError = null;

    this.equipmentStructureService.importFromExcel(this.importFile).subscribe({
      next: (result) => {
        this.importResult = result;
        this.isImporting = false;
      },
      error: (err) => {
        this.importError =
          err?.message ?? "Une erreur est survenue lors de l'importation.";
        this.isImporting = false;
      },
    });
  }
}
